<template>
  <div class="vant-table" ref="vantTable">
    <div class="table">
      <div class="table-header van-hairline--top">
        <div
          class="th"
          :class="{'large-th':item.key == 'createTime'}"
          v-for="(item) in option.column"
          :key="item.key"
        >{{ item.title }}</div>
      </div>
      <div class="table-body van-hairline--top">
        <div class="table-tr" v-for="(item, index) in tableData" :key="index">
          <div
            class="td"
            :class="{'large-td':context.key == 'createTime'}"
            v-for="(context, i) in option.column"
            :key="i"
          >{{ item[context.key] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BScroll from "better-scroll";
export default {
  props: {
    tableData: Array,
    option: Object,
  },
  data() {
    return {
      scroll: "",
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.vantTable, {
        scrollX: true,
        probeType: 3, // listening scroll hook
      });
    });
  },
};
</script>

<style lang="stylus" scoped>
.vant-table {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;

  .table {
    display: inline-block;
    color: #333333;
    width: 100%;

    // padding: 0px 24px;
    .table-header {
      height: 74px;
      line-height: 74px;
      display: flex;
      justify-content: center;
    }

    .table-tr {
      height: 74px;
      line-height: 74px;
      display: flex;
      justify-content: center;
    }

    .th, .td {
      display: inline-block;
      text-align: center;
      width: 20%;
    }

    .large-th, .large-td {
      // width: 200px;
      flex: 1;
    }

    .th {
      font-size: 26px;
      font-weight: bold;
    }

    .td {
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style>